module.exports = __webpack_public_path__ + "2c7b4a85d739fc32a0a8b2978815d367.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/user-gear.svg
// module id = 788
// module chunks = 0